import React, { useEffect, useState } from "react";
import { useAdvancedValidation } from "hooks/useAdvancedValidation";
import "./LocationTracking.css";
import MainLayout from "components/layout/main-layout/MainLayout";
import { titles } from "constants/titles";
import CustomButton from "components/widgets/custom-button/CustomButton";
import MessageSnackBar from "components/widgets/message-snackbar/MessageSnackBar";
import { IconTracking } from "assets/SVGs/SVGs";
import {
  callHeartBeatForClairvoyantDevice,
  getAneltoDeviceDetail,
  getAneltoTimeline,
  getClairvoyantTimeline,
  getEviewTimeLine,
  getFreeusDeviceDetail,
  getFreeusTimeline,
  getEviewDeviceDetail,
  setDeviceDetailLoaderVisibility,
  updateEviewFunction,
} from "redux/Devices/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  convertInRequiredTimeZone,
  getLastRefreshTimeInMinutes,
  getManualRefreshTime,
  isDisableManualRefresh,
} from "utility";
import { useHistory, useLocation } from "react-router-dom";
import ConfirmationModal from "components/layout/confirmation-modal/ConfirmationModal";
import { loader_gif, refresh_loop, curv } from "assets/images/images";
import {
  deviceLocationPayload,
  getCalculatedLastRefreshTime,
} from "../../utility/deviceDetailUtils";
import FrequentRequestPopup from "components/layout/frequent-request-popup/FrequentRequestPopup";

const LocationTracking = () => {
  const [locationSignalPopup, setLocationSignalPopup] = useState(false);
  const history = useHistory();
  const location = useLocation();

  // Initialize validation hook
  const { onApiResponse, snackbarState, dismissSnackbar } =
    useAdvancedValidation();
  const [deviceLocation, setDeviceLocation] = useState({
    latitude: location?.state?.item?.latitude
      ? parseFloat(location?.state?.item?.latitude, 10)
      : 0,
    longitude: location?.state?.item?.longitude
      ? parseFloat(location?.state?.item?.longitude, 10)
      : 0,
    latitudeDelta: 0.02,
    longitudeDelta: 0.02,
  });
  const [lastRefreshDetails, setLastRefreshDetails] = useState({
    time: "",
    city: "",
    state: "",
  });
  const [disableManualRefresh, setDisableManualRefresh] = useState(false);
  const [manualRefreshIntervalTime, setManualRefreshIntervalTime] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [eViewIntervalIndex, setEviewIntervalIndex] = useState(0);
  const [eViewInterval, setEviewInterval] = useState(false);
  const [frequentRequestPopup, setFrequentRequestPopup] = useState({
    data: null,
    isVisible: false,
  });
  const {
    aneltoDeviceDetails,
    selectedDeviceDetails,
    freeusDeviceDetails,
    loading,
    freeusIntervals,
    aneltoIntervals,
    clairvoyantIntervals,
    clairvoyantDeviceDetails,
    deviceDetailLoading,
    eViewDeviceDetails,
    eViewIntervalArray,
    manualRefreshLoading,
    deviceRefreshData,
  } = useSelector((store) => store?.devices);
  const userData = useSelector((store) => store?.auth?.userData);
  const { selectedMedicalUser } = useSelector(
    (store) => store?.medicalAlertUsers
  );
  const { currentTimeZone } = useSelector((store) => store?.common);
  const item = location?.state?.item;
  const isFromSignalHistory = location?.state?.isFromSignalHistory;
  const dispatch = useDispatch();

  useEffect(() => {
    const param = {
      dispatch,
      history,
      userType: userData?.isGuestUser ? "guestuser" : "accountowner",
    };
    getAneltoTimeline(param);
    getFreeusTimeline(param);
    getClairvoyantTimeline(param);
    getEviewTimeLine(param);
    return () => {
      setDeviceDetailLoaderVisibility(dispatch, false);
    };
  }, []);

  useEffect(() => {
    try {
      if (
        !isFromSignalHistory &&
        aneltoDeviceDetails &&
        Object?.keys(aneltoDeviceDetails)?.length > 0
      ) {
        checkManualRefreshButtonAccess();
        if (
          !aneltoDeviceDetails?.is_data_found ||
          aneltoDeviceDetails?.is_active_request
        ) {
          setTimeout(() => {
            getDeviceDetailManually();
          }, aneltoDeviceDetails?.next_interval_call);
        }
      }
    } catch (e) {}
  }, [aneltoDeviceDetails, deviceRefreshData]);

  useEffect(() => {
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    if (
      !isFromSignalHistory &&
      freeusDeviceDetails &&
      deviceType === "freeus"
    ) {
      checkManualRefreshButtonAccess();
    }
  }, [freeusDeviceDetails, deviceRefreshData]);

  useEffect(() => {
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    if (
      !isFromSignalHistory &&
      clairvoyantDeviceDetails &&
      deviceType === "clairvoyant"
    ) {
      checkManualRefreshButtonAccess();
    }
  }, [clairvoyantDeviceDetails, deviceRefreshData]);

  useEffect(() => {
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    if (eViewDeviceDetails && deviceType === "eview") {
      checkManualRefreshButtonAccess();
    }
  }, [eViewDeviceDetails, deviceRefreshData]);

  useEffect(() => {
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    let timeoutId = null;
    if (
      clairvoyantDeviceDetails &&
      deviceType === "clairvoyant" &&
      Object?.keys(clairvoyantDeviceDetails)?.length <= 0 &&
      currentIndex < clairvoyantIntervals?.intervals?.length
    ) {
      timeoutId = setTimeout(() => {
        getDeviceDetailManually();
        setCurrentIndex((prevIndex) => prevIndex + 1);
      }, clairvoyantIntervals?.intervals[currentIndex]);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [clairvoyantIntervals?.intervals, clairvoyantDeviceDetails]);

  useEffect(() => {
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    let timeoutId = null;
    if (
      eViewInterval &&
      deviceType === "eview" &&
      eViewIntervalArray?.intervals &&
      eViewIntervalIndex < eViewIntervalArray?.intervals?.length - 1 &&
      !disableManualRefresh
    ) {
      timeoutId = setTimeout(() => {
        const payload = {
          user_device_id: selectedDeviceDetails?.user_device_id,
          medical_alert_user_id: selectedDeviceDetails?.medical_alert_user_id,
          providerDeviceId: selectedDeviceDetails?.provider_device_id,
        };

        let param = {
          dispatch,
          payload,
          history,
          userType: userData?.isGuestUser ? "guestuser" : "accountowner",
          isInitialLoad: false,
        };
        getEviewDeviceDetail(param);
        setEviewIntervalIndex(eViewIntervalIndex + 1);
      }, eViewIntervalArray?.intervals?.[eViewIntervalIndex]);
    } else {
      setTimeout(() => {
        setDeviceDetailLoaderVisibility(dispatch, false);
        clearEviewInterval(timeoutId);
      }, 2000);
    }
    return () => {
      clearEviewInterval(timeoutId);
    };
  }, [eViewInterval, eViewIntervalIndex, selectedDeviceDetails]);

  const clearEviewInterval = (timeoutId) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  };

  useEffect(() => {
    if (!disableManualRefresh) return;
    const intervalId = setInterval(() => {
      setManualRefreshIntervalTime((prevTimer) => {
        if (prevTimer <= 0) {
          setDisableManualRefresh(false);
          if (intervalId) clearInterval(intervalId);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [disableManualRefresh]);

  useEffect(() => {
    if (!isFromSignalHistory) {
      let deviceDetail = null;
      const deviceType = selectedDeviceDetails?.device_type?.trim();
      if (deviceType === "anelto") {
        deviceDetail = aneltoDeviceDetails;
      } else if (deviceType === "clairvoyant") {
        deviceDetail = clairvoyantDeviceDetails;
      } else if (deviceType === "eview") {
        deviceDetail = {
          ...eViewDeviceDetails,
          latitude: eViewDeviceDetails?.latestLocation?.lat,
          longitude: eViewDeviceDetails?.latestLocation?.lng,
          created_at: eViewDeviceDetails?.generalData?.dateTime,
        };
      } else {
        deviceDetail = freeusDeviceDetails;
      }

      if (deviceDetail?.latitude || deviceDetail?.longitude) {
        setDeviceDetails(deviceDetail, deviceType);
      }
    }
  }, [selectedDeviceDetails]);

  const setDeviceDetails = async (deviceDetail, deviceType) => {
    setDeviceLocation({
      ...deviceLocation,
      latitude: parseFloat(deviceDetail?.latitude, 10),
      longitude: parseFloat(deviceDetail?.longitude, 10),
    });
    setLastRefreshDetails({
      ...lastRefreshDetails,
      time: deviceDetail?.created_at,
      city: deviceDetail?.city ?? "",
      state: deviceDetail?.state ?? "",
    });
  };

  const checkManualRefreshButtonAccess = () => {
    let deviceDetail = null;
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    if (deviceType === "anelto") {
      deviceDetail = aneltoDeviceDetails;
    } else if (deviceType === "clairvoyant") {
      deviceDetail = clairvoyantDeviceDetails;
    } else if (deviceType === "eview") {
      deviceDetail = {
        ...eViewDeviceDetails,
        created_at: eViewDeviceDetails?.generalData?.dateTime,
      };
    } else {
      deviceDetail = freeusDeviceDetails;
    }
    const manualRefreshTime = getManualRefreshTime(
      deviceType,
      aneltoIntervals,
      freeusIntervals,
      clairvoyantIntervals,
      eViewIntervalArray
    );
    const lastRequestedTime = getCalculatedLastRefreshTime(
      deviceRefreshData?.last_refresh_timestamp,
      deviceDetail?.data_timestamp
    );
    const isDisable = isDisableManualRefresh(
      lastRequestedTime,
      manualRefreshTime
    );
    setDisableManualRefresh(isDisable);
    if (isDisable && lastRequestedTime) {
      const diffInMin = getLastRefreshTimeInMinutes(lastRequestedTime);
      setManualRefreshIntervalTime((manualRefreshTime - diffInMin) * 60);
    } else {
      setManualRefreshIntervalTime(0);
    }
  };

  const getDeviceDetailManually = (isManual = false) => {
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    const payload = {
      user_device_id: selectedDeviceDetails?.user_device_id,
      medical_alert_user_id: selectedDeviceDetails?.medical_alert_user_id,
      last_interval_call:
        deviceType === "anelto"
          ? aneltoDeviceDetails?.next_interval_call || 0
          : undefined,
    };
    let param = {
      dispatch,
      payload,
      history,
      setSnackBarMessage: onApiResponse,
      userType: userData?.isGuestUser ? "guestuser" : "accountowner",
    };
    if (selectedDeviceDetails?.device_type?.trim() === "anelto") {
      getAneltoDeviceDetail(param, isManual);
    } else if (selectedDeviceDetails?.device_type?.trim() === "clairvoyant") {
      callHeartBeatForClairvoyantDevice({
        ...param,
        isRepeated: isManual ? false : true,
      });
    } else if (deviceType === "eview") {
      param.payload = {
        ...param?.payload,
        ...deviceLocationPayload,
        providerDeviceId: selectedDeviceDetails?.provider_device_id,
        isInitialLoad: false,
      };
      param = {
        ...param,
        isInitialLoad: false,
      };
      setEviewInterval(false);
      setEviewIntervalIndex(0);
      updateEviewFunction(param);
      setEviewInterval(true);
    } else {
      getFreeusDeviceDetail(param);
    }
  };

  const convertInLocalTimeZone = (date) => {
    return convertInRequiredTimeZone(
      date,
      selectedMedicalUser?.timezone,
      currentTimeZone
    );
  };

  const customSchemaForUI = () => {
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    let deviceDetail = null;
    if (deviceType === "anelto") {
      deviceDetail = aneltoDeviceDetails;
    } else if (deviceType === "clairvoyant") {
      deviceDetail = clairvoyantDeviceDetails;
    } else if (deviceType === "eview") {
      deviceDetail = {
        ...eViewDeviceDetails,
        created_at: eViewDeviceDetails?.generalData?.dateTime,
      };
    } else {
      deviceDetail = freeusDeviceDetails;
    }
    const lastRequestedTime = getCalculatedLastRefreshTime(
      deviceRefreshData?.last_refresh_timestamp,
      deviceDetail?.data_timestamp
    );

    return {
      lastRefreshTime: lastRequestedTime, //deviceRefreshData?.last_refresh_timestamp,
      dataTimeStamp: deviceDetail?.data_timestamp,
    };
  };

  const onManualRefreshClick = () => {
    if (manualRefreshLoading) {
      return;
    } else if (disableManualRefresh) {
      setFrequentRequestPopup({
        isVisible: true,
        lastRefreshTime: customSchemaForUI()?.lastRefreshTime,
      });
    } else {
      getDeviceDetailManually(true);
      setTimeout(() => {
        setLocationSignalPopup(true);
      }, 500);
    }
  };

  return (
    <MainLayout
      text={titles?.caregiver_tracking}
      isBackHide={false}
      isSemiHeader={true}
      white={true}
      primary={true}
      loading={loading}
      fullWidthScreen
    >
      {/* Snackbar - always sticky below header */}
      {snackbarState?.show && (
        <div className="snackbar_sticky">
          <MessageSnackBar
            message={snackbarState?.message}
            isVisible={true}
            type={snackbarState?.type}
            autoHideDuration={snackbarState?.autoHideDuration}
            onDismiss={dismissSnackbar}
          />
        </div>
      )}

      {deviceDetailLoading ? (
        <div className="gif_loader_container">
          <img height="50px" width="50px" src={loader_gif} alt="loader" />
        </div>
      ) : null}
      <div className="lt_content_container">
        <div className="lt_device_info_container">
          <h2 className="lt_device_title">
            {selectedDeviceDetails?.device_name}
          </h2>

          {!isFromSignalHistory ? (
            <CustomButton
              className="lt_update_button"
              text={
                manualRefreshLoading
                  ? titles?.updating
                  : titles?.update_location
              }
              onClick={() => {
                onManualRefreshClick();
              }}
              isGrayButton={disableManualRefresh || manualRefreshLoading}
              width="100%"
            />
          ) : null}

          <div className="lt_status_container">
            {isFromSignalHistory ? (
              <p className="lt_status_text">
                {`${titles?.device_status_information} ${convertInLocalTimeZone(
                  item?.date
                )}`}
              </p>
            ) : (
              <>
                {customSchemaForUI()?.lastRefreshTime && (
                  <p className="lt_status_text">
                    {titles?.last_refresh +
                      convertInLocalTimeZone(
                        customSchemaForUI()?.lastRefreshTime
                      )}
                  </p>
                )}
                {customSchemaForUI()?.dataTimeStamp && (
                  <p className="lt_status_text">
                    {`${
                      titles?.device_status_information
                    }${convertInLocalTimeZone(
                      customSchemaForUI()?.dataTimeStamp
                    )}`}
                  </p>
                )}
              </>
            )}
            <p className="lt_status_text">
              {`${lastRefreshDetails?.city}${
                lastRefreshDetails?.state ? ", " : ""
              }${lastRefreshDetails?.state}`}
            </p>
          </div>

          {manualRefreshLoading ? (
            <div className="lt_loading_container">
              <img
                src={refresh_loop}
                alt="Loading"
                className="lt_refresh_loop"
              />
              <p className="lt_loading_text">
                {titles?.hang_tight_app_refreshing}
              </p>
            </div>
          ) : null}
        </div>

        <div className="lt_map_container">
          <iframe
            src={`https://maps.google.com/maps?q=${deviceLocation?.latitude},${deviceLocation?.longitude}&z=15&output=embed`}
            width="100%"
            height="100%"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="lt_map"
            className="lt_map"
          ></iframe>
          <div className="lt_curved_section">
            <img src={curv} alt="Curve" className="lt_curved_image" />
          </div>
          <div
            className="lt_tracking_icon"
            onClick={() =>
              window.open(
                `https://www.google.com/maps?q=${deviceLocation?.latitude},${deviceLocation?.longitude}`,
                "_blank"
              )
            }
          >
            <IconTracking color="#fff" />
            <p className="lt_icon_text">{titles?.maps}</p>
          </div>
        </div>
      </div>

      <ConfirmationModal
        show={locationSignalPopup}
        setShow={setLocationSignalPopup}
        svgIcon={<IconTracking />}
        btnText={titles?.OK}
        title={titles?.location_signal}
        description={titles?.location_signal_desc}
        onClick={() => setLocationSignalPopup(false)}
      />
      <FrequentRequestPopup
        show={frequentRequestPopup?.isVisible}
        setShow={setFrequentRequestPopup}
        lastRefreshTime={frequentRequestPopup?.lastRefreshTime}
        deviceType={selectedDeviceDetails?.device_type?.trim()}
      />
    </MainLayout>
  );
};

export default LocationTracking;
